import {Icon, IconType, Text, Tooltip} from '@/ui-kits';
import {cn} from '@/utils/common_functions';
import {NA} from '@/constants';

interface DetailItemProps {
  label: string;
  value?: string;
  icon: IconType;
  className?: string;
  truncate?: boolean;
}
export const DetailItem: React.FC<DetailItemProps> = props => {
  const {label, value, icon, className, truncate} = props;

  const textLabel = (
    <Text variant="subtitle" className={cn('font-FigtreeSemiBold text-ui_text_black text-base', truncate && 'truncate')}>
      {value || NA}
    </Text>
  );
  return (
    <div className={cn(`flex items-start gap-3 bg-[#F8FAFC] p-3 sm:p-4 rounded-lg`, className)}>
      <div className="size-10 rounded-full bg-[#E8F4FD] flex items-center justify-center flex-shrink-0">
        <Icon type={icon} className="size-5" />
      </div>
      <div className="w-full min-w-0 max-w-full flex-shrink-1">
        <Text variant="body" className="!font-FigtreeSemiBold text-ui_blue text-base mb-1">
          {label}
        </Text>

        {truncate ? <Tooltip tooltipClassName='w-fit' className='max-w-full' message={value || NA}>{textLabel}</Tooltip> : textLabel}
      </div>
    </div>
  );
};
